import { CardData, CardProps } from "../../types";

export const useCardData = (
  isSelected: boolean,
  currentCard: CardData | null,
  originalCard: {
    title: string;
    category: string;
    content?: string;
    attributes?: CardProps['attributes'];
    pointOfInterest?: number;
  }
) => {
  const displayContent = isSelected && currentCard ? currentCard.content : originalCard.content;
  const displayTitle = isSelected && currentCard ? currentCard.title : originalCard.title;
  const displayCategory = isSelected && currentCard ? currentCard.category : originalCard.category;
  const displayAttributes = isSelected && currentCard ? currentCard.attributes : originalCard.attributes;

  const relevanceValue = (() => {
    const match = displayCategory.match(/Relevance: ([\d.]+)/);
    if (match && match[1]) {
      return Math.round(parseFloat(match[1]) * 100);
    }
    return originalCard.pointOfInterest || 0;
  })();

  return {
    displayContent,
    displayTitle,
    displayCategory,
    displayAttributes,
    relevanceValue,
  };
};